import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { TableauAiAccesses } from "./accesses.ts";
import { TableauAiComponents } from "./components.ts";
import { TableauIconUrl } from "./icon.ts";

const TableauAiFilters = {
  site: { keys: ["name"] },
  // Rule filter values compile to regular expressions, so rules can scope by
  // level ("read:.*") or exactly ("write:<project id>").
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type TableauAiFilters = typeof TableauAiFilters;

export const TableauAiRegistration = Registration({
  accesses: TableauAiAccesses,
  category: "resource",
  components: TableauAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/tableau",
    request: "agentic-gateway/requesting-access",
  },
  filters: TableauAiFilters,
  itemKind: "Site",
  label: "Tableau",
  logoUrl: TableauIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("tableau-ai", TableauAiRegistration);
